import { LicenseType } from 'core/constants';

export function getLicenseTypeText(message: string): LicenseType | null {
  if (message === LicenseType.ProtectorMonitoringVatix || message === LicenseType.ProtectorMonitoringSelf)
    return message;
  return null;
}
